import React, { useState, useEffect } from 'react';
import clsx from 'classnames';
import PropTypes from 'prop-types';
import { makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  container: {
    /* tighten spacing and center header content */
    marginBottom: 5,
    marginTop: theme.spacing(4),
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center'
  },
  title: {
    fontSize: 18,
    color: theme.palette.text.primary,
    fontWeight: 'bold'
  },
  [theme.breakpoints.down('xs')]: {
    title: {
      fontSize: 16
    }
  }
}));

const Header = ({ className, title }) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.container, className)}>
      <Typography className={classes.title}>{title}</Typography>
    </div>
  );
};

Header.propTypes = {
  className: PropTypes.any,
  title: PropTypes.string.isRequired,
};

Header.defaultProps = {
  className: null,
};

export default Header;
